// extracted by mini-css-extract-plugin
export default {"background":"Memory_background__6C9nc","portrait":"Memory_portrait__+Vl2f","landscape":"Memory_landscape__Hn7rT","removeButton":"Memory_removeButton__gqP4N"};